import React, { Component } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReferralHash from "../../../../common/referral-hash";

import {
  signUpAction,
  confirmEmailAction,
  signInAction,
  resetPasswordAction,
  createPasswordAction,
  changeEmailAction,
} from "features/application/authentication/redux/actions";

import { removeFieldsCorrectnessAction } from "features/application/field/redux/actions";

import AuthenticationView from "features/application/authentication/component/view";
import {
  getInvitationHash,
  getRegistrationHash,
} from "../../../../screens/shared-event/utils/eventsStorageUtils";

const mapStateToProps = (state) => ({
  validFields: state.fieldReducer.validFields,
});

const mapDispatchToProps = (dispatch) => ({
  signUp: (
    email,
    password,
    referrer,
    code,
    hash,
    referral,
    shareHash,
    invitationHash
  ) =>
    dispatch(
      signUpAction(
        email,
        password,
        referrer,
        code,
        hash,
        referral,
        shareHash,
        invitationHash
      )
    ),
  confirmEmail: (id, expires, signature) =>
    dispatch(confirmEmailAction(id, expires, signature)),
  signIn: (email, password) => dispatch(signInAction(email, password)),
  resetPassword: (email) => dispatch(resetPasswordAction(email)),
  createPassword: (email, password, token) =>
    dispatch(createPasswordAction(email, password, token)),
  changeEmail: (id, email, parameters) =>
    dispatch(changeEmailAction(id, email, parameters)),
  removeFieldsCorrectness: () => dispatch(removeFieldsCorrectnessAction()),
});

class Authentication extends Component {
  constructor(props) {
    super(props);

    this.formReference = React.createRef();

    this.sendApiRequest = this.sendApiRequest.bind(this);
  }

  componentDidMount() {
    const {
      currentStep,
      urlUserId,
      urlEmailId,
      urlParameters,
      history,
      confirmEmail,
      changeEmail,
    } = this.props;

    if (urlUserId && urlParameters) {
      if (currentStep === "sign-in") {
        confirmEmail(
          urlUserId,
          queryString.parse(urlParameters.replace("+", "%2B")).expires,
          queryString.parse(urlParameters.replace("+", "%2B")).signature
        );

        localStorage.setItem("emailConfirmed", true);
      } else if (currentStep === "change-email") {
        changeEmail(urlUserId, urlEmailId, urlParameters);
      } else if (currentStep === "sign-up") {
        queryString.parse(urlParameters.replace("+", "%2B")).email &&
          (document.querySelector(
            '.field__input[name="referrer"]'
          ).value = queryString.parse(urlParameters.replace("+", "%2B")).email);

        queryString.parse(urlParameters.replace("+", "%2B")).code &&
          (document.querySelector(
            '.field__input[name="code"]'
          ).value = queryString.parse(urlParameters.replace("+", "%2B")).code);
      }
    } else if (currentStep === "change-email") {
      history.replace("/application/sign-in");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentStep, removeFieldsCorrectness } = this.props;

    nextProps.currentStep &&
      nextProps.currentStep !== currentStep &&
      removeFieldsCorrectness();
  }

  sendApiRequest(event) {
    event.preventDefault();

    const {
      currentStep,
      urlUserId,
      urlParameters,
      validFields,
      signUp,
      signIn,
      resetPassword,
      createPassword,
    } = this.props;

    let fields = event.target.elements;
    let focusEvent = new Event("focus", { bubbles: true, cancelable: true });
    let blurEvent = new Event("blur", { bubbles: true, cancelable: true });

    for (let i = 0; i < fields.length; i++) {
      fields[i].dispatchEvent(focusEvent);
      fields[i].dispatchEvent(blurEvent);
    }

    switch (currentStep) {
      case "sign-up":
        if (urlUserId === "premium") {
          validFields.includes("email") &&
            validFields.includes("password") &&
            validFields.includes("code") &&
            validFields.includes("referrer") &&
            signUp(
              fields.email.value,
              fields.password.value,
              fields.referrer.value,
              fields.code.value,
              localStorage.getItem("referral_hash")
                ? localStorage.getItem("referral_hash")
                : ReferralHash.hash,
              null,
              getRegistrationHash(),
              getInvitationHash()
            );
        } else {
          validFields.includes("email") &&
            validFields.includes("password") &&
            signUp(
              fields.email.value,
              fields.password.value,
              null,
              null,
              localStorage.getItem("referral_hash")
                ? localStorage.getItem("referral_hash")
                : ReferralHash.hash,
              null,
              getRegistrationHash(),
              getInvitationHash()
            );
        }
        break;
      case "referral":
        validFields.includes("email") &&
          validFields.includes("password") &&
          validFields.includes("referral") &&
          signUp(
            fields.email.value,
            fields.password.value,
            null,
            null,
            localStorage.getItem("referral_hash")
              ? localStorage.getItem("referral_hash")
              : ReferralHash.hash,
            fields.referral.value,
            getRegistrationHash(),
            getInvitationHash()
          );
        break;
      case "sign-in":
        validFields.includes("email") &&
          validFields.includes("password") &&
          signIn(fields.email.value, fields.password.value);
        break;
      case "reset-password":
        validFields.includes("email") && resetPassword(fields.email.value);
        break;
      case "create-password":
        urlParameters &&
          validFields.includes("password") &&
          createPassword(
            queryString.parse(urlParameters.replace("+", "%2B")).email,
            fields.password.value,
            queryString.parse(urlParameters.replace("+", "%2B")).token
          );
        break;
    }
  }

  getCookie(name) {
    let cookies = `; ${document.cookie}`;
    let parts = cookies.split(`; ${name}=`);

    return parts.length === 2 && parts.pop().split(";").shift();
  }

  render() {
    const { responseCodes, errorCodes, currentStep, urlUserId } = this.props;

    return (
      <AuthenticationView
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        currentStep={currentStep}
        urlUserId={urlUserId}
        formReference={this.formReference}
        sendApiRequest={this.sendApiRequest}
      />
    );
  }
}

Authentication.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  currentStep: PropTypes.string,
  urlUserId: PropTypes.string,
  urlParameters: PropTypes.string,
  urlEmailId: PropTypes.number,
  history: PropTypes.object,
  confirmEmail: PropTypes.func,
  changeEmail: PropTypes.func,
  removeFieldsCorrectness: PropTypes.func,
  validFields: PropTypes.array,
  signUp: PropTypes.func,
  signIn: PropTypes.func,
  resetPassword: PropTypes.func,
  createPassword: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);
